<template>
    <div
        ref="words"
        class="sensitive-words-cell"
    >
        <!-- <span
            v-for="(item, index) in sensitiveWords"
            v-show="index < showCount"
            :key="index"
            class="sensitive-words-cell__word"
        >{{ item }}</span> -->
        <div v-for="(item, index) in sensitiveWords" v-show="index < showCount" :key="index" @click="handlerTag(item)" class="sensitive-words-cell__word">
            <v-tag
                color="white"
                :text="item"
                class="sensitive-words-cell__word"
            />
        </div>
        <more-items-tip
            v-if="isOverflow"
            clazz="sensitive-words-cell__overflow"
            :list="sensitiveWords"
            :unit="$t('个')"
            :max-num="44"
        />
    </div>
</template>

<script>
/* eslint-disable */

import { Icon } from 'vhtml-ui';
import moreItemsTip from '../more-items-tip';

const req = require.context('@/assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);

export default {
    name: 'SensitiveWordsCell',
    components: {
        moreItemsTip
    },
    props: {
        sensitiveWords: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            showCount: this.sensitiveWords.length,
            isOverflow: false
        };
    },
    computed: {},
    watch: {
        sensitiveWords(newValue) {
            this.showCount = newValue.length;
            this.isOverflow = false;
            this.$nextTick(function() {
                this.reduceWords();
            });
        }
    },
    mounted() {
        this.reduceWords();
    },
    methods: {
        reduceWords() {
            // console.log(this.$refs.words.offsetHeight, this.$refs.words.scrollHeight);
            if (this.$refs.words.scrollHeight > this.$refs.words.offsetHeight) {
                if (!this.isOverflow) this.isOverflow = true;
                this.showCount--;
                if (this.showCount > 0) this.$nextTick(this.reduceWords);
            }
        },
        handlerTag(item){
            this.$emit('onTagClick', item);
        }
    }
};
</script>

<style lang="less">
@import '~@/common/common';

.sensitive-words-cell {
    margin-top: 4px;
    max-height: 92px;
    overflow: auto;

    &__word,
    &__overflow {
        float: left;
        margin-bottom: 4px;
    }

    &__word {
        margin-right: 4px;
        // border-radius: 30px;
        // background-color: #e4e8ea;
        max-width: 100px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
</style>
